import { getQrCodeImg } from '@/api/common';

export default {
	data() {
		return {
			xcx_qrcode: '',
			host_app_key: '',
		};
	},
	computed: {},
	methods: {
		async initIMG() {
			const { xcx_qrcode } = await getQrCodeImg();
			this.xcx_qrcode = xcx_qrcode;
			// 使用函数获取参数并提取所需的键值对
			let queryParams = this.getParams(xcx_qrcode);
			this.host_app_key = queryParams['host_app_key'] || '';
		},
		// 提取参数的函数
		getParams(url) {
			let params = {};
			let queryString = url.split('?')[1];
			if (queryString) {
				let keyValuePairs = queryString.split('&');
				for (let i = 0; Number(i) < keyValuePairs.length; i++) {
					let pair = keyValuePairs[i].split('=');
					params[pair[0]] = decodeURIComponent(pair[1]);
				}
			}
			return params;
		},
	},
};
